import { render } from "./DepositInvoiceDeductionItem.vue?vue&type=template&id=65330b06"
import script from "./DepositInvoiceDeductionItem.vue?vue&type=script&lang=js"
export * from "./DepositInvoiceDeductionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__